import type { RootState } from '@app/model/types'
import { getPageStateSafe } from '@app/model/store/helpers'

import { appHomeInitialState } from './initialState'
import type { AppHomeState } from './types'

export const selectAppHomeState = (state: RootState): AppHomeState =>
  getPageStateSafe(state, 'app_home', appHomeInitialState)

export const selectAppHomeSections = (state: RootState) => selectAppHomeState(state).sections
